import React from 'react';

import { Link } from 'react-resource-router';

import Heading from '@atlaskit/heading';
import Warning from '@atlaskit/icon/glyph/warning';
import { Text, Box, Stack, Inline } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { urls } from 'src/components/settings/gpg-keys/urls';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../../../gpg-keys.i18n';

import { Content, IconBackground, Card } from './unverified-card.style';

export const GpgKeysUnverifiedCard = (): JSX.Element | null => {
  const { formatMessage } = useIntl();

  return (
    <Inline xcss={Card}>
      <Box xcss={IconBackground}>
        <Warning
          label={formatMessage(messages.unverifiedLabel)}
          primaryColor={token('color.background.input', colors.N20)}
          secondaryColor={token('color.background.warning.bold', colors.Y300)}
        />
      </Box>
      <Stack xcss={Content}>
        <Heading level="h600" as="h3">
          {formatMessage(messages.notVerifiedTitle)}
        </Heading>
        <Text size="small">
          {formatMessage(messages.notVerifiedDescription)}{' '}
          <Link href={urls.gpgKeyCreation}>
            {formatMessage(messages.configureGpgKeysText)}
          </Link>
        </Text>
      </Stack>
    </Inline>
  );
};
